import { useQuery } from '@tanstack/react-query';
import { getApiBaseUrl } from '@/lib/api-base-url';
import { authFetch } from '@/lib/auth-fetch';

// A StoneX metal broker trade the operator can attach as a contract reference
// on the Allocate Broker Fill form — the metals mirror of FxTradeCandidate.
// The tradeId becomes hedge_execution.contract_reference; decimals/dates
// arrive as strings from the backend to stay JSON-stable.
export interface MetalTradeCandidate {
  tradeId: string;
  underlyer: string | null;
  side: string | null;
  lots: string | null;
  contractSize: string | null;
  quantityMt: string | null;
  price: string | null;
  tradeDate: string | null;
  promptDate: string | null;
  securityDescription: string | null;
}

async function fetchMetalTradeCandidates(metal?: string): Promise<MetalTradeCandidate[]> {
  const url = new URL(`${getApiBaseUrl()}/hedging/metal-trade-candidates`);
  if (metal !== undefined && metal !== '') {
    url.searchParams.set('metal', metal);
  }
  const response = await authFetch(url.toString());
  if (!response.ok) {
    throw new Error(`Request failed (${String(response.status)})`);
  }
  return (await response.json()) as MetalTradeCandidate[];
}

export const HEDGING_METAL_TRADE_CANDIDATES_QUERY_KEY = [
  'hedging',
  'metal-trade-candidates',
] as const;

// `enabled` lets callers defer the fetch until the picker is actually opened.
// The endpoint is flag-gated (metal-trade-ref-picker) and 404s while off, so
// callers only mount this hook on the flag-on path.
export function useMetalTradeCandidates(metal?: string, enabled = true) {
  return useQuery({
    queryKey: [...HEDGING_METAL_TRADE_CANDIDATES_QUERY_KEY, metal ?? null],
    queryFn: () => fetchMetalTradeCandidates(metal),
    enabled,
  });
}
